// extracted by mini-css-extract-plugin
export default {"wrapper":"Group_wrapper__C-h4j","detail":"Group_detail__lgMrS","treeSelect":"Group_treeSelect__oMDSC"};